<div
  *ngFor="let stepGroup of stepsFormArray.controls; let i = index; trackBy: trackByIndex"
  [formGroup]="getStepGroup(i)"
  class="bg-gray-50 rounded p-4 relative"
>
  <div class="flex items-center justify-between mb-2">
    <span class="font-semibold text-lg">
      {{ i === 0 ? 'Construction Sheet:' : 'Construction Step ' + i + ':' }}
    </span>
    <button
      *ngIf="i > 0 && !viewDisable"
      mat-icon-button
      color="warn"
      (click)="onRemoveStepClick($event, i)"
      aria-label="Delete step"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Construction text</mat-label>
    <textarea
      matInput
      formControlName="description"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      [cdkAutosizeMaxRows]="1000"
      placeholder="Enter construction details"
      [readonly]="readonly"
      (click)="onReadonlyClick($event)"
    ></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full mt-4">
    <mat-label>Memo</mat-label>
    <textarea
      matInput
      formControlName="memo"
      placeholder="Enter memo"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      [cdkAutosizeMaxRows]="1000"
    ></textarea>
  </mat-form-field>

  <!-- Extra checkboxes sourced from Order Custom Job fields -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
    <!-- Client Part # -->
    <div class="flex items-center gap-2">
      <div class="relative inline-block">
        <span
          [matTooltip]="'You can\'t select fields without values.'"
          [matTooltipDisabled]="getParentFieldValue('clientPartNo') !== ''"
        >
          <mat-checkbox
            [checked]="
              isChecked(getStepGroup(i), 'clientPartNo', getParentFieldValue('clientPartNo'), i)
            "
            (change)="
              onCheckboxChange(
                getStepGroup(i),
                'clientPartNo',
                getParentFieldValue('clientPartNo'),
                $event.checked
              )
            "
            [disabled]="
              viewDisable || getParentFieldValue('clientPartNo') === '' || isOrdersManager()
            "
          >
            Client Part #:
            {{ viewDisable ? order.details[0].clientPartNo : getParentFieldValue('clientPartNo') }}
          </mat-checkbox>
        </span>
      </div>
    </div>

    <!-- Feet Per Reel -->
    <div class="flex items-center gap-2">
      <div class="relative inline-block">
        <span
          [matTooltip]="'You can\'t select fields without values.'"
          [matTooltipDisabled]="getParentFieldValue('feetPerReel') !== ''"
        >
          <mat-checkbox
            [checked]="
              isChecked(getStepGroup(i), 'feetPerReel', getParentFieldValue('feetPerReel'), i)
            "
            (change)="
              onCheckboxChange(
                getStepGroup(i),
                'feetPerReel',
                getParentFieldValue('feetPerReel'),
                $event.checked
              )
            "
            [disabled]="
              viewDisable || getParentFieldValue('feetPerReel') === '' || isOrdersManager()
            "
          >
            Feet Per Reel:
            {{ viewDisable ? order.details[0].feetPerReel : getParentFieldValue('feetPerReel') }}
          </mat-checkbox>
        </span>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
    <ng-container *ngFor="let field of specFields; trackBy: trackByFieldKey">
      <div class="flex flex-col gap-2">
        <div
          *ngFor="
            let value of specification?.[field.key] || [];
            let j = index;
            trackBy: trackByValue
          "
        >
          <div class="flex items-center gap-2">
            <div class="relative inline-block">
              <span
                [matTooltip]="'You can\'t select fields without values.'"
                [matTooltipDisabled]="!(value === null || value === '')"
              >
                <mat-checkbox
                  [checked]="isChecked(getStepGroup(i), field.key, value)"
                  (change)="onCheckboxChange(getStepGroup(i), field.key, value, $event.checked)"
                  [disabled]="viewDisable || value === null || value === '' || isOrdersManager()"
                >
                  {{ field.label }}: {{ value }}
                </mat-checkbox>
              </span>
              <div
                *ngIf="readonly && field.key !== 'putUp' && field.key !== 'supplier'"
                class="absolute inset-0 z-10"
                (click)="onReadonlyClick($event)"
                title="Read only"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="flex justify-end" *ngIf="!viewDisable && !isOrdersManager()">
  <button mat-flat-button color="primary" type="button" (click)="onAddStepClick($event)">
    <mat-icon>add</mat-icon>
    Add Step
  </button>
</div>
